module.exports = __webpack_public_path__ + "static/media/f1.962f5ae1.jpeg";